<template>
  <aside
    :id="'connect-step'"
    :class="'connect-overlay connect-overlay--connect-step' + (totalSteps > 0 && currentStep === totalSteps ? '-final' : '')"
    v-if="integration"
  >
    <div class="connect-overlay-header">
      <div class="wrap wrap--connect-overlay-header">
        <ul class="connect-overlay-header__list">
          <li v-if="currentStep > 1" class="connect-overlay-header__item">
            <button class="connect-overlay-header__link connect-overlay-header__link--back"
              @click.prevent="goBack()"
            >Go Back</button>
          </li>
          <li class="connect-overlay-header__item">
            <router-link class="connect-overlay-header__link" :to="{ name: 'Help' }">Help</router-link>
          </li>
        </ul>

        <button type="button" class="connect-overlay-header__close"
          @click.prevent="close()"
        >close</button>
      </div>
    </div>

    <div class="connect-overlay-content">
      <div class="wrap wrap--connect-overlay-content">
        <header class="connect-overlay-content-header">
          <ul class="connect-overlay-content-header__list">
            <li class="connect-overlay-content-header__item">
              <h2 class="connect-overlay__title">Connect.</h2>
            </li>
            <li class="connect-overlay-content-header__item">
              <i class="integration__icon" :class="'integration__icon--' + slugify(integration.name)"></i>
              <span class="connect-overlay-content-header__name">{{ integration.name }}</span>
            </li>
          </ul>
        </header>

        <div class="connect-overlay__info">
          <p>Step {{ currentStep }}/{{ totalSteps }} - {{ integration._links.setup.steps[currentStep - 1] }}</p>
        </div>

        <ul v-if="steps" class="connect-overlay__list">
          <li class="connect-overlay__item"
            @mouseenter="mouseEvent"
            @mouseleave="mouseEvent"
            v-for="(option, key) in steps"
            :key="key"
          >
            <button type="button" class="connect-overlay-button"
              @click.prevent="goForward(option._links.self, option.id)"
            >
              <ul class="connect-overlay-button__list">
                <li class="connect-overlay-button__item">
                  <span class="connect-overlay-button__account">{{ option.name }}</span>
                </li>
                <li class="connect-overlay-button__item">
                  <span class="connect-overlay-button__id">{{ option.id }}</span>
                </li>
              </ul>

              <i class="connect-overlay-button__next"
                v-if="option._links.self.method === 'GET'"
              >
                <span class="hide--visually">Next</span>
              </i>
              <span class="connect-overlay-button__connect button-outline"
                v-if="option._links.self.method === 'POST'"
              >Connect</span>
            </button>
          </li>

        </ul>

        <div class="connect-overlay-footer">
          <p>🤔 Don't see your account? <a class="connect-overlay-footer__link"
            :href="integration._links.authorize_url.href"
            target="_parent"
          >Choose a different login.</a></p>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
  import { helpers } from '@/mixins/helpers.js'

  import axios from 'axios'

  export default {
    name: 'connect',
    props: {
      integration: {
        default: null,
        type: Object
      },
      show: {
        default: false,
        type: Boolean
      }
    },
    mixins: [helpers],
    data () {
      return {
        currentStep: 0,
        steps: null,
        totalSteps: 0,
        urls: null
      }
    },
    methods: {
      close () {
        this.toggleClass('connect-step-active', 'connect-overlay-transition', 500)
        this.$emit('closed')
      },
      goBack () {
        this.currentStep = this.currentStep - 1
        this.loadStep(this.urls[this.currentStep])
      },
      goForward (link, id = null) {
        if (link.method === 'POST') {
          this.setOption(link, id)
        } else {
          this.currentStep = this.currentStep + 1
          this.loadStep(link)
        }
      },
      loadStep (link) {
        let that = this
        this.steps = null

        return axios({
          url: link.href
        })
        .then((response) => {
          that.steps = response.data
          that.urls[that.currentStep] = link
        })
        .catch((error) => {
          console.log(error)
        })
      },
      loadSetup () {
        this.currentStep = 0
        this.steps = null
        this.totalSteps = this.integration._links.setup.total_steps
        this.urls = {}
        this.goForward(this.integration._links.setup)
      },
      mouseEvent (e) {
        let previous = e.currentTarget.previousElementSibling

        if (previous !== null) {
          if (e.type === 'mouseenter') {
            previous.classList.add('hover')
          }

          if (e.type === 'mouseleave') {
            previous.classList.remove('hover')
          }
        }
      },
      setOption (link, id) {
        let that = this
        let data = {}
        data[link.field] = id

        return axios({
          method: link.method,
          url: link.href,
          data: data
        })
        .then((response) => {
          this.integration.is_setup = true
          that.$emit('setupIntegrationComplete', this.integration)
          that.close()
        })
        .catch((error) => {
          console.log(error)
        })
      }
    },
    watch: {
      integration: function () {
        if (this.integration !== null) {
          this.loadSetup()
        }
      },
      show: function (value) {
        if (value) {
          this.toggleClass('connect-step-active', 'connect-overlay-transition', 500)
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/js/components/Connect.vue